import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReCAPTCHA from 'react-google-recaptcha'
import { connect } from 'react-redux'
import {
    CaptchaValueFieldName,
    RESPONSIVE_SCREEN_WIDTH_LARGE,
    personCustomerType,
} from '../constants/GeneralConstants'

const ReCAPTCHAWrapper = styled.div`
    margin-bottom: 20px;
    margin-left: 30px;
    float: left;
    width: 50%;
    @media (max-width: ${props => props.theme.responsive.large}) {
        transform: scale(0.80);
        transform-origin: 0 0;
        margin-left: 0%;
    }
`

class Captcha extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLargeView: false,
        }
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    }

    componentDidMount() {
        this.updateWindowDimensions()
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions() {
        this.setState({ isLargeView: window.innerWidth > RESPONSIVE_SCREEN_WIDTH_LARGE })
    }


    onRecaptchaChange = (reCaptchaValue) => {
        const { setFieldValue } = this.props
        setFieldValue(CaptchaValueFieldName, reCaptchaValue)
    }

    render() {
        const { values, customerType } = this.props
        return(
            <ReCAPTCHAWrapper
                className={customerType === personCustomerType
                    ? this.state.isLargeView
                        ? 'personCaptchaWrapper'
                        : ''
                    : ''
                }
            >
                <ReCAPTCHA
                    sitekey="6LfrSH0iAAAAABYqCxiGWMVMABD2LcYttiFpjVhm"
                    onChange={this.onRecaptchaChange}
                    hl={values.personLanguage || values.businessLanguage}
                />
            </ReCAPTCHAWrapper>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        customerType: state.customerTypeReducer.customerType,
    }
}

Captcha.propTypes = {
    setFieldValue: PropTypes.func,
    values: PropTypes.object,
    isPerson: PropTypes.bool,
    customerType: PropTypes.string,
}

export default connect(mapStateToProps)(Captcha)
